import { createContext, useContext } from "react";

import { VariableDef } from "@/types/resources";

/**
 * Variables available to a question's text for `{{placeholder}}` highlighting
 * and autocomplete. Provided once per question by `Question` (merging the
 * parent section's variables with the question's own), so the deeply-nested
 * `QuestionTextInput` can consume them without prop-drilling through every
 * question-type editor.
 */
const QuestionVariablesContext = createContext<VariableDef[]>([]);

export const QuestionVariablesProvider = QuestionVariablesContext.Provider;

export const useQuestionVariables = (): VariableDef[] =>
  useContext(QuestionVariablesContext);
